export default __webpack_public_path__ + "static/media/paragrapgh-icon.f25919f0.svg";